import { formatTime } from "../utils/date";

export const SLOT_STEP = 15; // minutes per slot

export function toMySQLDateTime(dtLocal: string): string {
  if (!dtLocal) return "";
  const [date, time] = dtLocal.split("T");
  return `${date} ${time}:00`;
}

export function fromMySQLToLocal(dt: string): string {
  // Floating time: map 'YYYY-MM-DD HH:MM:SS' -> 'YYYY-MM-DDTHH:MM'
  if (!dt) return "";
  return dt.slice(0, 16).replace(' ', 'T');
}

export function computeTimeRange(dt: string, durationMinutes: number): string {
  // dt: 'YYYY-MM-DD HH:MM:SS' in floating time
  const timePart = (dt.split(' ')[1] || '00:00:00');
  const [h = 0, m = 0] = timePart.split(':').map(Number);
  const startLabel = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
  const total = h * 60 + m + (Number(durationMinutes) || 0);
  const eh = Math.floor(total / 60) % 24;
  const em = total % 60;
  const endLabel = `${String((eh + 24) % 24).padStart(2, '0')}:${String((em + 60) % 60).padStart(2, '0')}`;
  return `${startLabel}–${endLabel}`;
}

export function startOfWeek(date: Date) {
  const d = new Date(date);
  const day = (d.getDay() + 6) % 7; // Monday=0
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() - day);
  return d;
}

export function fmtRangeLabel(d: Date) {
  const end = new Date(d);
  end.setDate(d.getDate() + 6);
  const pad2 = (n: number) => String(n).padStart(2, '0');
  const fmt = (x: Date) => `${pad2(x.getDate())}/${pad2(x.getMonth() + 1)}`;
  return `${fmt(d)} – ${fmt(end)}`;
}
